<template>
  <div id="prod-editor">
    <mt-header fixed title="生成产品溯源码">
      <router-link :to="'/prod/view?id=' + prodId" slot="left">
        <mt-button icon="back">返回</mt-button>
      </router-link>
    </mt-header>
    <mt-field label="每箱产品数" placeholder="请输入一个包装内产品数量" type="number" v-model="prodInfo.pkgNum"><span>个/箱</span></mt-field>
    <mt-field label="总包装箱数" placeholder="请输入需要生成的溯源码总箱数" type="number" v-model="prodInfo.packages"><span>箱</span></mt-field>
    <mt-field label="溯源码总数" type="number" readonly :value="codeTotalNum"><span>个</span></mt-field>
    <mt-field label="备注" placeholder="请输入备注" type="textarea" rows="5" v-model="prodInfo.remark"></mt-field>
    <div class="page-btn">
      <mt-button type="primary" size="large" @click.native="downCode">生成</mt-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import "mint-ui/lib/style.css";
import {Toast, Cell, Button, Field, Header, Indicator} from "mint-ui";

export default {
  props: ["prodId","pkgNum"],
  components: {Toast, Cell, Button, Field, Header, Indicator},
  data: function() {
    return {
      prodInfo: {
        id: null,
        pkgNum: 1,
        packages: 0,
        remark: null
      }
    };
  },
  computed: {
    codeTotalNum(){
      return this.prodInfo.pkgNum * this.prodInfo.packages
    }
  },
  methods: {
    downCode: function(){
      if(this.prodInfo.packages <= 0){
        Toast("总包装箱数不能小于1");
        return;
      }
      Indicator.open();
      this.$http
        .post(this.GLOBAL.serverUrl + "/ent/prod/" + this.prodId + "/afcode/create", this.prodInfo)
        .then(function(resp) {
          Indicator.close();
          if (resp.body.code == 200) {
            this.$router.push("/prod/view?id=" + this.prodId);
          } else if (resp.body.code == 500) Toast(resp.body.msg || "操作失败，请稍后再试！");
        });
    }
  }
};
</script>
<style scoped>
#prod-editor {
  padding-top: 5rem;
}
.page-btn {
  margin-top: 2rem;
  padding: 0 1rem;
}
</style>